import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle} from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Select,
  Button,
  Space,
  message,
  DatePicker,
  Input
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import dayjs from "dayjs";
import commonFn from "@/utils/commonFn";

const AplianceModal = forwardRef(({ submitInitFn }, ref) => {
    const [form] = Form.useForm();
    const [type, setType] = useState('add');
    const [oldState, setOldState] = useState({});
    const [modalName, setModalName] = useState('Payment Request');
    const [modalFlag, setModalFlag] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [storeList, setStoreList] = useState([]);
    
    useImperativeHandle(ref, () => ({
      openModal: ({type, modalName, oldState}) => {
        setType(type)
        setModalName(modalName)
        setOldState(oldState)
        setModalFlag(true)
      }
    }));

    const afterOpenChangeFn = (flag) => {
      if(flag){
        if(type !== 'add'){
          getDetailFn()
        } else {
        }
      }else{
        form.resetFields();
        setBtnLoading(false)
        setBtnDisabled(false)
      }
    }

    const testFn = async () => {
    }

    const getDetailFn = async() => {
      if(!oldState?.id) return
      setBtnDisabled(true)
      const response = await http.get(api.aplianceDetail, { params: {id: oldState.id}});
      if (response.code === "1") {
        const { purchaseTime } = response.data
        const temp = {
          ...response.data,
          purchaseTime: purchaseTime && dayjs(purchaseTime),
        }
        form.setFieldsValue(temp);
      }
      setBtnDisabled(false)
    }
    

    const submitAddOrEditFn = async(type) => {
      const flag = type === 'add'
      setBtnLoading(true)
      const { purchaseTime } = form.getFieldValue()
      const response = await http.post(flag ? api.aplianceAdd : api.aplianceUpdate, {
        ...form.getFieldValue(),
        purchaseTime: purchaseTime?.format('YYYY-MM-DD') || '',
        type: oldState.type
      });
      if (response.code === "1") {
        message.success(`${flag ? 'New' : 'Edit'} successfully`);
        setModalFlag(false)
        submitInitFn();
      } else {
        commonFn.modalFailedFn(response)
      }
      setBtnLoading(false)
    }

    const submitFn = async() => {
      form.validateFields().then(value => {
        if(type === 'add' || type === 'edit'){
          submitAddOrEditFn(type)
        }
      }).catch(err =>{
        console.log(err,'===err');
      })
    }

    const getAplianceStoreList = async () => {
      const response = await http.get(api.aplianceStoreList);
      setStoreList(response?.data || []);
    };  
  
    useEffect(() => {
      getAplianceStoreList();
    }, []);

  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "#3c8dbc" }}>
          <HomeOutlined style={{ marginRight: "8px" }} />
          {modalName}
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      maskClosable={false}
      afterOpenChange={afterOpenChangeFn}
      width="30%"
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{span: 8}}
        wrapperCol={{span: 16}}
        labelWrap={true}
        labelAlign="right"
        validateMessages={{
          required: "${label} is required!",
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              name="qrCode"
              label="Number"
              rules={[{ required: true, message: 'Number is required!' }]}
            >
              <Input
                placeholder="Please input Number"
              />
            </Form.Item>

            <Form.Item
              name="purchaseTime"
              label="PO.Date"
              rules={[{ required: true, message: 'PO.Date is required!' }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format="MM/DD/YYYY"
              />
            </Form.Item>

            <Form.Item
              name="appStoreId"
              label="Store Name"
              rules={[{ required: true, message: 'Store Name is required!' }]}
            >
              <Select
                showSearch
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={storeList}
              />
            </Form.Item>

          </Col>
        </Row>
      </Form>
      <div style={{textAlign:'center'}}>
        <Space align="center">
          {/* <Button key="back" onClick={testFn}>
            TEST
          </Button> */}
          <Button key="back" onClick={() => setModalFlag(false)}>
            Cancel
          </Button>
          {
            type !== 'view' && (
              <Button type="primary" onClick={() => submitFn()} loading={btnLoading} disabled={btnDisabled}>
                Submit
              </Button>
            ) || null
          }
        </Space>
      </div>
    </Modal>
  );
});

export default AplianceModal;